'use client'

import React from 'react';
import { useRouter } from "next/navigation";
import Image from 'next/image';
import {
  IconMessageCircle,
  IconChevronLeft,
  IconBuilding,
  IconRefresh
} from '@/components/ui/icons-v2';

export const dynamic = 'force-dynamic'
const Fallback = () => {
    const router = useRouter();

    const handleRefresh = () => {
        window.location.reload();
    };

    return (
      <div className="flex h-full flex-col items-center justify-center min-h-screen dark:bg-slate-950 text-center p-4">
        <div className="mb-4">
          <Image
            src="/i_logo/i_primary/Vertical/Black/PNG/mixus-logo-primary-vertical-black.png"
            alt="mixus"
            width={100}
            height={133}
            className="dark:hidden"
          />
          <Image
            src="/i_logo/i_primary/Vertical/Knockout/PNG/mixus-logo-primary-vertical-white.png"
            alt="mixus"
            width={100}
            height={133}
            className="hidden dark:block"
          />
        </div>

        <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
          Page Not Found
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md">
          We&apos;re sorry, but something went wrong. <br /> Please try again later.
        </p>

        <div className="flex flex-col w-full max-w-md gap-4">
          <button
            onClick={handleRefresh}
            className="flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition-colors duration-200 shadow-lg transform hover:scale-105 font-medium mx-auto w-full max-w-sm"
          >
            <IconRefresh className="w-5 h-5 animate-spin-slow" />
            <span>Refresh Page</span>
          </button>

          <div className="flex flex-row gap-2 justify-center flex-wrap">
            <button
              onClick={() => router.push('/chat')}
              className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition-colors duration-200 shadow-lg min-w-[120px]"
            >
              <IconMessageCircle className="w-4 h-4" />
              <span>Start Chat</span>
            </button>
            <button
              onClick={() => router.push('/')}
              className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors duration-200 shadow-lg min-w-[120px]"
            >
              <IconBuilding className="w-4 h-4" />
              <span>Home</span>
            </button>
            <button
              onClick={() => router.back()}
              className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-200 shadow-lg min-w-[120px]"
            >
              <IconChevronLeft className="w-4 h-4" />
              <span>Back</span>
            </button>
          </div>
        </div>
      </div>
    )
};

export default Fallback;
